import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { EM_DASH } from 'constants/ui';

export const CIC_SAVE_REASON_NAME = 'Material Loan Term Change';

export const CIC_SAVE_NOTE_MAX_LENGTH = 500;

export const CicReasonAppliesTo = {
  FEE: 'Fee',
  LOAN_TERM: 'LoanTerm',
};

export const EMPTY_COMMENT_TEMPLATES = [];

export const CIC_REASON_NAME_MAX_LENGTH = 100;

export const CIC_REASON_DESCRIPTION_MAX_LENGTH = 250;

export const CicDisclosureType = {
  REVISED_LE: 'RevisedLe',
  REVISED_CD: 'RevisedCd',
};

export const CicBundleType = {
  CIC_LE: 'CicLe',
  CIC_CD: 'CicCd',
};

export const CicChangeRemovalCause = {
  SUPERSEDED_BY_LATER_CHANGE: 'SupersededByLaterChange',
  VALUE_REVERTED: 'ValueReverted',
  GROUP_CANCELLED_BY_MANUAL_UPLOAD: 'GroupCancelledByManualUpload',
};

export const CIC_DATE_TIME_FORMAT = `${COMMON_DATETIME_FORMAT} [CT]`;

export const CIC_EMPTY_DISPLAY_VALUE = EM_DASH;
